/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, OnInit } from '@angular/core';
import { ShuttleSuppliers } from '../../../../shared/lists';
import { SuppliersModel } from '../../../../shared/models';
import { UtilsService } from '../../../../../../core/services';

@Component({
    selector: 'app-downloads',
    templateUrl: './select-shuttle.component.html',
    styleUrls: ['../../../../../../../assets/shared/scss/page-rows.scss']
})
export class SelectShuttleComponent implements OnInit {
    /**
     * List of suppliers.
     */
    public ShuttleSupplierRows: SuppliersModel[] = [];

    constructor(
        private utilsService: UtilsService
    ) {
    }

    ngOnInit(): void {
        this.populateSupplierRows();
    }

    /**
     * Populate supplier rows
     * @private
     */
    private populateSupplierRows(): void {
        const rows: any[] = [];
        for (const supplier of ShuttleSuppliers) {
            if (supplier.vendorId !== 7) {
                if (supplier.vendorId !== 5) {
                    supplier.active = false;
                }
                rows.push(supplier);
            }
        }

        this.ShuttleSupplierRows = this.utilsService.sortArrayByProperty(rows, 'active', [true, false]);
    }

}
